import { useContext } from 'react';
import { AngularContext } from 'react-app';

type RolePlayPermissions = {
  isAdminOrMentor: boolean;
  isEnrolled: boolean;
};

const useRolePlayPermissions = (): RolePlayPermissions => {
  const { injectServices } = useContext(AngularContext);
  const [CurrentPermissionsManager, CurrentCourseManager] = injectServices(['CurrentPermissionsManager', 'CurrentCourseManager']);

  return {
    isAdminOrMentor: !!(
      CurrentPermissionsManager?.hasCourseAdminPermissions()
      || CurrentPermissionsManager?.hasOrgMentorPermissions()
      || CurrentPermissionsManager?.isMentor()
    ),
    isEnrolled: !!CurrentCourseManager?.course?.userCourse?.isEnrolled,
  };
};

export default useRolePlayPermissions;
